import { SaveBookUserDataToDB } from "../database/bookUserDataTable.js";

export function GetBookProgress(book, bookUserData) {
    if (!book || !bookUserData || !bookUserData.pagesVisited || bookUserData.pagesVisited.length === undefined)
      return 0;
    var pageCount = book.numberOfPages;
    if (!pageCount || pageCount <= 0) return 0;
    var visitedCount = bookUserData.pagesVisited.length;
    var pageProgress = visitedCount / pageCount;
    var timeCount = bookUserData.timeSpent ?? 0;
    var timeTarget = book.narrationTime ? book.narrationTime * 0.6 : 0;
    var timeProgress = timeTarget > 0 ? (timeCount / timeTarget) : 1;
    return Math.min(1, Math.min(pageProgress, timeProgress));
}

export function HasBook(item)
{
  return item.book && item.book.length !== 0;
}

export function IsContinues(bookUserData)
{
  return HasBook(bookUserData) && GetBookProgress(bookUserData.book, bookUserData) < 1;
}

export async function fetchBlackList(dispatch, accessToken, userId)
{
  try {
    var myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", "Bearer " + accessToken);
      
      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
      };
      const response = await fetch(process.env.REACT_APP_APIBASE + "mobile/books/blacklist?&userId=" + userId, requestOptions);
      const data = await response.json();


      console.log("data res: " + JSON.stringify(data));
      const bookIds = data.result.bookIds;
      var key = userId + "_blacklist";
      localStorage.setItem(key, JSON.stringify(bookIds));
  } catch(excpetion) {
    console.error(excpetion);
  }
}

export async function fetchBookUserData(dispatch, accessToken, userId) {
    try {
      var myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("Authorization", "Bearer " + accessToken);
      
      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };
      const response = await fetch(process.env.REACT_APP_APIBASE + "mobile/child/" + userId + "/bookUserData", requestOptions);
      const data = await response.json();
      const list = data.result.list;
      list.forEach(item => {
        item.id = item.bookId + "_" + userId;
        item.favourite = item.favourite ? 1 : 0;
        item.readLater = item.readLater ? 1 : 0;
        item.assignedByTeachers = item.assignedByTeachers ? 1 : 0;
        item.parentRecommended = item.parentRecommended ? 1 : 0;
        item.userId = userId;
      });
      await SaveBookUserDataToDB(dispatch, userId, list);
    } catch(excpetion) {
      console.error(excpetion);
    }
  }

export async function SaveBookUserData(dispatch, bookUserData, accessToken, onReturned) {
    try {
        const userId = bookUserData.userId;
        var myHeaders = new Headers();
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", "Bearer " + accessToken);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify(bookUserData);

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        const response = await fetch(process.env.REACT_APP_APIBASE + "mobile/child/" + userId + "/bookUserData/" + bookUserData.bookId, requestOptions);
        const errorMessage =  { code : 500, message : "Save Failed" };
        if (!response.ok) throw errorMessage;

        await fetchBookUserData(dispatch, accessToken, userId);
        if (onReturned)
          onReturned(true, "Logged In");
    } catch (error) {
        console.log('error', error);
        onReturned(false, error.message);
    };
}
